import { Suspense, type FC } from 'react';

import { ShoppingCartIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@repo/ui/components/common';

import { CartCountBadge } from '@/components/common/CartCountBadge';
import { LocaleLink } from '@/components/common/LocaleLink';

export const CartButton: FC = () => {
  const { t } = useTranslation();

  return (
    <Button asChild variant="ghost" aria-label={t('cart.title')} className="relative mr-1">
      <LocaleLink to="/cart">
        <ShoppingCartIcon className="size-6" />
        <Suspense fallback={null}>
          <CartCountBadge />
        </Suspense>
      </LocaleLink>
    </Button>
  );
};
